import React from "react";
import PropTypes from "prop-types";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';

const SeasonCard = ({
  children,
  imageSrc,
  imageTitle,
  objectPosition,
}) => (
    <Grid item xs={12} sm={6}>
      <Card
        sx={{height: '100%'}}
      >
        <CardMedia
          component="img"  
          image={imageSrc}
          alt={imageTitle}
          height="261"
          sx={{
            objectFit: "cover",
            objectPosition: objectPosition,
          }}
            
        />
        <CardContent sx={
          {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            boxSizing: 'border-box',
            height: 'calc(100% - 261px)',
            '&:last-child': { pb: 2 }
          }
        }>
          {children}
        </CardContent>
      </Card>
    </Grid>
  );

SeasonCard.propTypes = {
  children: PropTypes.arrayOf(PropTypes.element).isRequired,
  imageSrc: PropTypes.string,
  imageTitle: PropTypes.string,
  objectPosition: PropTypes.string,
};

export default SeasonCard;
